import React, { Component } from 'react';
import { Link } from "gatsby"
import t from 'prop-types';
import { isAbsoluteUrl } from '../../utils/url';

class Button extends Component {
  static propTypes = {
    href: t.string,
    children: t.oneOfType([t.string, t.array]),
  };
  render() {
    const { className, href, target, children, ...props } = this.props;
    const _className = `wwc-button ${className}`;
    if(href) {
      if(isAbsoluteUrl(href) || target === '_blank' ) {
        return (<a className={_className} {...props} href={href} rel="noopener noreferrer" target="_blank">{ children }</a>); // eslint-disable-line react/jsx-no-duplicate-props
      }
      return (<Link className={_className} {...props} to={href} className="wwc-button">{ children }</Link>); // eslint-disable-line react/jsx-no-duplicate-props
    }

    return <button className={_className} {...props}>{children}</button>;    
  }
}

export default Button;